/******************************************************************************************
 *	Person Name Filter
 *******************************************************************************************
 *
 * Takes an object and the property names for first and last name (in that order) and
 * returns the full name formatted according to $locale.
 * If no firstNameProperty or lastNameProperty are set, they default to `first_name` and
 * `last_name` respectively.
 *
 */
(function() {
  

  // eslint-disable-next-line lodash/prefer-lodash-method
  angular.module('rcFilters.personName', []).filter(
    'personName',
    /* @ngInject */
    function(locale) {
      return function(person, firstNameProperty, lastNameProperty) {
        if (!person) {
          return '';
        }

        firstNameProperty = firstNameProperty || 'first_name';
        lastNameProperty = lastNameProperty || 'last_name';

        var firstName = person[firstNameProperty];
        var lastName = person[lastNameProperty];

        if (!firstName && !lastName) {
          return null;
        }

        var fullName = [firstName, lastName];
        var invertName = locale.isSurnameFirstNameLocale();

        if (invertName) {
          fullName.reverse();
        }
        return fullName.join(' ');
      };
    }
  );
})();
